
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
    side: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      statsOpen: false,
    };
  },
  computed: {
    positionClass () {
      return this.player.position === `Substitute` ? `bg-grey300` : `bg-primary`;
    },
    isSub () {
      return this.player.position === `Substitute`;
    },
    goals () {
      return this.player.goal;
    },
  },
};
